import { NO_SUBSCRIPTION_MESSAGE } from 'constants/messages';

const NO_SUBSCRIPTION_ENTITLEMENT_ERROR = 'Failed to validate entitlement, no subscription data';
export const NO_SUBSCRIPTION_MODAL_EVENT = 'rpl-robot:no-subscription-entitlement';

let lastNoSubscriptionModalAt = 0;

const getErrorMessage = (errorData) => {
    if (typeof errorData === 'string') return errorData;
    return errorData?.message || errorData?.error || '';
};

export const isNoSubscriptionEntitlementError = (errorData) =>
    Boolean(errorData?.isNoSubscriptionEntitlement) || getErrorMessage(errorData).includes(NO_SUBSCRIPTION_ENTITLEMENT_ERROR);

export const notifyNoSubscriptionEntitlement = () => {
    const now = Date.now();
    if (now - lastNoSubscriptionModalAt < 1500) return;

    lastNoSubscriptionModalAt = now;
    window.dispatchEvent(
        new CustomEvent(NO_SUBSCRIPTION_MODAL_EVENT, {
            detail: {
                isOpen: true,
                title: 'Subscription Required',
                message: NO_SUBSCRIPTION_MESSAGE,
                type: 'error'
            }
        })
    );
};
